module.exports = __webpack_public_path__ + "img/profile_nophoto_color.23c9714.png";